import { Mapper } from '../../../../base/utils/mapper';
import { ScheduleProfessionalModel } from '../../../../domain/models/configuration/schedule-professional.model';

import { ScheduleProfessionalEntity } from '../entities/schedule-professional.entity';

export class ScheduleProfessionalImplementationRepositoryMapper
  extends Mapper<ScheduleProfessionalEntity, ScheduleProfessionalModel>
{
  mapFrom(param: ScheduleProfessionalEntity): ScheduleProfessionalModel {
    return {
      ...param,
    };
  }

  mapTo(param: ScheduleProfessionalModel): ScheduleProfessionalEntity {
    return {
      ...param,
    };
  }
}